import { render, staticRenderFns } from "./AdminConfigRoot.vue?vue&type=template&id=7b943324"
import script from "./AdminConfigRoot.vue?vue&type=script&lang=ts"
export * from "./AdminConfigRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports